export const socialMediaLinks = [
  {
    href: "#",
    title: "Facebook",
    iconClass: "fa-facebook-f",
    name: "Facebook",
  },
  {
    href: "#",
    title: "X",
    iconClass: "fa-x-twitter",
    name: "X",
  },
  {
    href: "#",
    title: "Instagram",
    iconClass: "fa-instagram",
    name: "Instagram",
  },
  {
    href: "https://www.youtube.com/@DevSkillsStudio",
    title: "YouTube",
    iconClass: "fa-youtube",
    name: "YouTube",
  },
  {
    href: "https://www.linkedin.com/company/devskills-development-studio",
    title: "LinkedIn",
    iconClass: "fa-linkedin-in",
    name: "LinkedIn",
  },
  {
    href: "#",
    title: "WhatsApp",
    iconClass: "fa-whatsapp",
    name: "WhatsApp",
  },
];

export const navigationLinks = [
  { href: "#about", text: "About" },
  { href: "#services", text: "Services" },
  { href: "#portfolio", text: "Portfolio" },
  { href: "#blog", text: "Blog" },
  { href: "#contact", text: "Contact" },
];
